<template>
  <div :style="style" style="display: flex;flex-direction: column; width: 100px;" v-show="show"
       @mousedown.stop
       @contextmenu.prevent
  >
    <slot style="padding: 20px 20px 10px 20px;"></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'context-menu',
  data () {
    return {
      triggerShowFn: () => {},
      triggerHideFn: () => {},
      x: null,
      y: null,
      style: {},
      binded: false
    }
  },
  props: {
    show: ''
  },
  mounted () {
    this.bindEvents()
  },
  watch: {
    show (show) {
      if (show) {
        this.bindHideEvents()
      } else {
        this.unbindHideEvents()
      }
    },
    contextMenuElement: {
      handler: function (val) {
        this.binded = false
        this.bindEvents()
      },
      deep: true
    }
  },
  methods: {
    // 初始化事件
    bindEvents () {
      this.$nextTick(() => {
        if (!this.contextMenuElement || this.binded) return
        // console.log('contextMenuHandler')
        this.triggerShowFn = this.contextMenuHandler.bind(this)
        this.contextMenuElement.addEventListener('contextmenu', this.triggerShowFn)
        this.binded = true
      })
    },

    // 取消绑定事件
    unbindEvents () {
      if (!this.contextMenuElement) return
      this.contextMenuElement.removeEventListener('contextmenu', this.triggerShowFn)
    },

    // 绑定隐藏菜单事件
    bindHideEvents () {
      this.triggerHideFn = this.clickDocumentHandler.bind(this)
      document.addEventListener('mousedown', this.triggerHideFn)
      document.addEventListener('mousewheel', this.triggerHideFn)
    },

    // 取消绑定隐藏菜单事件
    unbindHideEvents () {
      document.removeEventListener('mousedown', this.triggerHideFn)
      document.removeEventListener('mousewheel', this.triggerHideFn)
    },

    // 鼠标按压事件处理器
    clickDocumentHandler (e) {
      this.$emit('update:show', false)
    },

    // 右键事件事件处理
    contextMenuHandler (e) {
      this.x = e.clientX
      this.y = e.clientY
      this.layout()
      // console.log('contextMenuHandler')
      this.$emit('update:show', this.target)
      e.preventDefault()
    },

    // 布局
    layout () {
      this.style = {
        left: this.x + 'px',
        top: this.y + 'px'
      }
    }
  },
  computed: {
    ...mapState(['contextMenuElement', 'target'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VueContextMenu.vue